import { styled } from '@material-ui/core';
import React from 'react';

export const VideoContainer = styled('div')({
  height: '100vh',
  width: '100vw',
  position: 'absolute',
  background: 'black',
});
